/**
 * Analytics client callable from non-React contexts (workers, plain modules).
 * Wraps the PostHog helpers; all functions are safe to call server-side (no-op).
 */
import { trackEvent } from '@/lib/posthog'

export type IntentEvent = 'intent_enqueued' | 'intent_completed' | 'intent_failed'

export function trackIntent(event: IntentEvent, properties: Record<string, unknown>) {
  trackEvent(event, properties)
}

export type TicketEvent = 'sent_queued' | 'sent_completed' | 'sent_failed'

export function trackTicket(event: TicketEvent, properties: Record<string, unknown>) {
  trackEvent(`ticket_${event}`, properties)
}
